export const widgetConfig = {
    hotelId: 'babylon',
    ticker: '',
    engine: 'witbooking',
    showPrice: false,
    defaultAdults: 2,
    defaultChildren: 0,
    currency: 'EUR',
    baseUrl: 'http://booking.babylon.com/',
    urlChain: 'chain/babylon_agr',
    urlHotel: 'hotel',
    showChildAges: false,
    noOnDesktop: false,
    type: 'chain',
    maxRooms: '5',
    showAllHotelsOption: 'true',
    targetBlank: true,
    maxDate: '2028-01-01',
};
